import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/app.css'
import { applySettings } from './lib/settings'

applySettings()

// Browserens egen "Installér app"-bjælke skal ikke vises
window.addEventListener('beforeinstallprompt', (e) => e.preventDefault())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
